import Button from '@rockalingua/ui/components/Button/Button';

import type { SurveyActionProps } from '../../types/surveyAction';

export default function ContinueAction({
  disabled,
  isSubmitting,
  onSubmit,
}: SurveyActionProps) {
  return (
    <Button
      type="primary"
      disabled={disabled || isSubmitting}
      loading={isSubmitting}
      onClick={onSubmit}
    >
      Continue
    </Button>
  );
}
